export default __webpack_public_path__ + "static/media/misc-pantry3-1920w.e03caf86.webp";